import isEmpty from 'lodash/isEmpty';
import dayjs from 'dayjs';
import Yup from '../../../../vendor/yup';
import { targetValidation } from '../../../../const/targetValidation';



export const NEWS_TEMPLATE_CONTENT_TYPE = 'news';

export const mkValidationSchema = (initialValues = {}, dynamicData = {}) => Yup.lazy((values) => {
  return Yup.object().shape({
    status: Yup.bool().test(
      'status',
      'Status can not be On until template, title, published at, published to and any of required fields are empty',
      (value) => {

        if (!value) {
          return true;
        }

        return values?.template_id && values?.title
        && values?.published_at && values?.published_to;
      },
    ),
    template_id: Yup.number().required('Template is required'),
    title: Yup.string().nullable().max(2000),
    released_at: Yup.date()
      .when('is_published', {
        is: false,
        then: (schema) => schema.nullable(),
        otherwise: (schema) => schema.required('Required to specify released at date'),
      })
      .test(
        'test_day_in_the_past',
        'Released at date must be same or after than yesterday',
        (value) => {
          if (!isEmpty(initialValues) && dayjs(value).isSame(dayjs(initialValues.released_at))) {
            return true;
          }

          return !dayjs(value).isBefore(dayjs()
            .subtract(1, 'days').startOf('day')
            .utc(false));
        },
      )
      .test(
        'test_date_after',
        'Released at date must be same or before than released to',
        (value) => {
          if (!isEmpty(values?.released_to) && !isEmpty(value)) {
            return dayjs(values?.released_to).isSameOrAfter(value);
          }
          return true;
        },
      ),
    released_to: !values.is_published ? Yup.date().nullable() :
      Yup.string().required('Required to specify released to date')
        .test(
          'test_day_in_the_past',
          'Released to date must be same or after than yesterday',
          (value) => {
            if (!isEmpty(initialValues) && dayjs(value).isSame(dayjs(initialValues.released_to))) {
              return true;
            }

            return !dayjs(value).isBefore(dayjs(new Date())
              .subtract(1, 'days').startOf('day')
              .utc(false));
          },
        )
        .test(
          'test_date_before',
          'Released to date must be same or after than released at',
          (value) => {
            if (!isEmpty(values?.released_at) && !isEmpty(value)) {
              return dayjs(values?.released_at).isSameOrBefore(value);
            }
            return true;
          },
        ),
    is_published: Yup.bool().nullable(),
    use_utc_zero_time: Yup.bool(),
    target: targetValidation,
    ...dynamicData,
  });
});
